var _rect, _rect2, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMintbathrooms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_187_9640)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#CFD8DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_9640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 20,
    height: 21
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_9640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8327 22.0003C19.3743 22.0003 18.982 21.8371 18.6556 21.5107C18.3292 21.1844 18.166 20.792 18.166 20.3337C18.166 19.8753 18.3292 19.483 18.6556 19.1566C18.982 18.8302 19.3743 18.667 19.8327 18.667C20.291 18.667 20.6834 18.8302 21.0098 19.1566C21.3362 19.483 21.4993 19.8753 21.4993 20.3337C21.4993 20.792 21.3362 21.1844 21.0098 21.5107C20.6834 21.8371 20.291 22.0003 19.8327 22.0003ZM18.166 32.8337C17.9299 32.8337 17.732 32.7538 17.5723 32.5941C17.4125 32.4344 17.3327 32.2364 17.3327 32.0003C16.8743 32.0003 16.482 31.8371 16.1556 31.5107C15.8292 31.1844 15.666 30.792 15.666 30.3337V25.3337H18.166V24.7087C18.166 24.1809 18.3466 23.7364 18.7077 23.3753C19.0688 23.0142 19.5132 22.8337 20.041 22.8337C20.3188 22.8337 20.5757 22.8892 20.8118 23.0003C21.048 23.1114 21.2632 23.2642 21.4577 23.4587L22.6243 24.7503C22.7355 24.8614 22.8431 24.9656 22.9473 25.0628C23.0514 25.16 23.166 25.2503 23.291 25.3337H28.9993V18.542C28.9993 18.3475 28.9299 18.1809 28.791 18.042C28.6521 17.9031 28.4855 17.8337 28.291 17.8337C28.2077 17.8337 28.1278 17.851 28.0514 17.8857C27.975 17.9205 27.9021 17.9725 27.8327 18.042L26.791 19.0837C26.8605 19.3198 26.8743 19.5524 26.8327 19.7816C26.791 20.0107 26.7077 20.2225 26.5827 20.417L24.291 18.0837C24.4855 17.9587 24.6938 17.8788 24.916 17.8441C25.1382 17.8094 25.3605 17.8337 25.5827 17.917L26.6243 16.8753C26.8466 16.6531 27.1 16.4795 27.3848 16.3545C27.6695 16.2295 27.9716 16.167 28.291 16.167C28.9577 16.167 29.5202 16.3962 29.9785 16.8545C30.4368 17.3128 30.666 17.8753 30.666 18.542V25.3337H32.3327V30.3337C32.3327 30.792 32.1695 31.1844 31.8431 31.5107C31.5167 31.8371 31.1243 32.0003 30.666 32.0003C30.666 32.2364 30.5862 32.4344 30.4264 32.5941C30.2667 32.7538 30.0688 32.8337 29.8327 32.8337H18.166Z",
    fill: "#666666"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_187_9640",
    x: -9.53674e-7,
    y: 0.499999,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_187_9640"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_187_9640",
    result: "effect2_dropShadow_187_9640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_187_9640",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintbathrooms);
export default __webpack_public_path__ + "static/media/mintbathrooms.a5a76c0e7e8aaa95b9480c786ffd33a5.svg";
export { ForwardRef as ReactComponent };